export const UNMUTE_REQUEST_KIND = "unmute_request";
export const UNMUTE_REQUEST_TOPIC = "li-participant-control";

function normalizeTargetIdentities(targetIdentities = []) {
  return [...new Set(
    (Array.isArray(targetIdentities) ? targetIdentities : [targetIdentities])
      .map((value) => String(value || "").trim())
      .filter(Boolean)
  )];
}

export function buildUnmuteRequestPayload({
  senderIdentity = "",
  senderName = "",
  targetIdentities = [],
} = {}) {
  return {
    v: 1,
    kind: UNMUTE_REQUEST_KIND,
    sender: String(senderIdentity || "").trim(),
    name: String(senderName || "").trim(),
    target_identities: normalizeTargetIdentities(targetIdentities),
  };
}

export function parseUnmuteRequestDataPayload(payload) {
  try {
    const text = new TextDecoder().decode(payload);
    const data = JSON.parse(text);
    if (data?.v !== 1 || data?.kind !== UNMUTE_REQUEST_KIND) {
      return null;
    }
    return {
      sender: String(data.sender || "").trim(),
      name: String(data.name || "").trim(),
      targetIdentities: normalizeTargetIdentities(
        data.target_identities || data.targetIdentities || data.targets || []
      ),
    };
  } catch {
    return null;
  }
}

export async function publishUnmuteRequest(
  room,
  localParticipant,
  { senderName = "", targetIdentities = [] } = {}
) {
  const resolvedLocalParticipant = localParticipant || room?.localParticipant || null;
  const normalizedTargets = normalizeTargetIdentities(targetIdentities);
  if (!room?.localParticipant || !resolvedLocalParticipant) {
    throw new Error("Meeting controls are not ready yet.");
  }
  if (!normalizedTargets.length) {
    throw new Error("No candidate was selected for the unmute request.");
  }
  const body = JSON.stringify(
    buildUnmuteRequestPayload({
      senderIdentity: resolvedLocalParticipant.identity || "",
      senderName,
      targetIdentities: normalizedTargets,
    })
  );
  await room.localParticipant.publishData(new TextEncoder().encode(body), {
    reliable: true,
    topic: UNMUTE_REQUEST_TOPIC,
  });
  return normalizedTargets;
}
